// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JEcI4UOElpC0MOoBn1Np {
	background-color: var(--gray);
	display: flex;
	flex-direction: column;
}
._tDr_fAhuJpRq5kTfOWk {
	padding: 20px 32px;
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
}
.yYT2m5Vqtz62WmKTn9bu {
	display: flex;
	flex-direction: column;
	padding: 20px 32px 32px;
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
}
.TeFXs9y5aEbJ6TDDEa7i {
	display: flex;
	flex-direction: column;
}
.TeFXs9y5aEbJ6TDDEa7i > * {
	border-top: 0.5px solid rgba(0, 0, 0, 0.2);
}
.SuUMOWCzBY7tVB_gqirQ {
	color: var(--black);
	font-size: 16px;
	letter-spacing: -0.08em;
	line-height: 24px;
	margin-bottom: 8px;
}
.TlfTs5mAc9OkpwNPq5zl {
	display: inline;
	max-width: 300px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
@media (max-width: 767px) {
.TlfTs5mAc9OkpwNPq5zl {
		max-width: 200px;
}
	}
.xb3bmVVPyiET87rQ2biT {
	margin-top: 32px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LockSettingsPage/IncreaseAmount/IncreaseAmount.pcss"],"names":[],"mappings":"AAEA;CACC,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,4CAA4C;AAC7C;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,4CAA4C;AAC7C;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;AAEA;CACC,0CAA0C;AAC3C;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;AACnB;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AAKpB;AAHC;AAPD;EAQE,gBAAgB;AAElB;CADC;AAED;CACC,gBAAgB;AACjB","sourcesContent":["@import '../../../stylesheets/media-queries.pcss';\n\n.container {\n\tbackground-color: var(--gray);\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.input {\n\tpadding: 20px 32px;\n\tbox-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);\n}\n\n.content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 20px 32px 32px;\n\tbox-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);\n}\n\n.changes {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.changes > * {\n\tborder-top: 0.5px solid rgba(0, 0, 0, 0.2);\n}\n\n.title {\n\tcolor: var(--black);\n\tfont-size: 16px;\n\tletter-spacing: -0.08em;\n\tline-height: 24px;\n\tmargin-bottom: 8px;\n}\n\n.lockAmount {\n\tdisplay: inline;\n\tmax-width: 300px;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\n\t@media (--mobile) {\n\t\tmax-width: 200px;\n\t}\n}\n.approveButton {\n\tmargin-top: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JEcI4UOElpC0MOoBn1Np`,
	"input": `_tDr_fAhuJpRq5kTfOWk`,
	"content": `yYT2m5Vqtz62WmKTn9bu`,
	"changes": `TeFXs9y5aEbJ6TDDEa7i`,
	"title": `SuUMOWCzBY7tVB_gqirQ`,
	"lockAmount": `TlfTs5mAc9OkpwNPq5zl`,
	"approveButton": `xb3bmVVPyiET87rQ2biT`
};
export default ___CSS_LOADER_EXPORT___;
